"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.number.constructor");require("core-js/modules/es6.number.is-integer");require("core-js/modules/es6.function.name");






















































































var _user = require("@/utils/user");
var _formatter = require("@/utils/formatter");
var _Patient = _interopRequireDefault(require("@/components/Patient")); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { components: { DoctorPatients: _Patient.default }, data: function data() {return { tableData: [], // 列表数据
      imageList: [], newadd: false, name: '', searchData: { name: '', bedspace: '', page: 1, // 页码条数
        rows: 10 }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, addData: { id: '', name: '', age: '', complaint: '', hospitalTime: '', bedspace: '', sex: '' }, rules: { name: [{ required: true, message: '请输入病房号', trigger: 'blur' }], age: [{ required: true, validator: this.handleCheckAge, trigger: 'blur' }], bedspace: [{ required: true, validator: this.handleCheckMobile, trigger: 'blur' }], sex: [{ required: true, message: '请输入性别', trigger: 'blur' }], hospitalTime: [{ required: true, message: '请输入入院时间', trigger: 'blur' }], complaint: [{ required: true, message: '请输入主诉', trigger: 'blur' }] }, // 表格列
      tableColumns: [{ prop: 'name', label: '姓名', isShow: true }, { prop: 'ward', label: '床位', formatter: function formatter(row, column, val) {if (row.ward) {return row.ward + ',' + row.bedspace;}}, isShow: true }, { prop: 'hospitalTime', formatter: _formatter.dateSimpleFormatter, label: '入院时间', isShow: true }] };

  },
  mounted: function mounted() {
    var self = this;
    self.init();
  },
  methods: {
    init: function init(doctorId) {
      var self = this;
      self.getData('/api/temi/medical/patient/doctor/' + self.$route.params.parentId, self.searchData, function (res) {
        self.tableData = res.list;
        self.pageData.page = res.pageNum;
        self.pageData.total = res.total;
      });
    },
    checkPermission: _user.checkPermission,
    resetFun: function resetFun() {// 重置
      this.searchData.name = '';
      this.searchData.bedspace = '';
      this.init();
    },
    searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;
      this.init();
    },
    handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;
      this.searchData.page = 1;
      this.init();
    },
    handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;
      this.init();
    },
    addFun: function addFun() {// 新增
      this.name = '新增';
      this.$refs.doctorPatient.handleShow = true;
      this.$refs.doctorPatient.init();
    },
    closeDiglog: function closeDiglog() {// 关闭弹出层
      this.$refs['addForm'].resetFields();
      this.cleanData();
      this.newadd = false;
      this.newadd2 = false;
    },
    updateMenu: function updateMenu(item) {// 修改操作
      this.name = '修改';
      var self = this;
      self.newadd = true;
      self.addData = {
        id: item.id,
        name: item.name,
        age: item.age,
        complaint: item.complaint,
        hospitalTime: item.hospitalTime,
        bedspace: item.bedspace,
        sex: item.sex + '' };

    },
    handleLookPatient: function handleLookPatient(item) {
      console.log(item);
    },
    handlePostPatients: function handlePostPatients(patients) {// 新增提交操作
      console.log('pati', patients);
      if (patients && patients.length > 0) {
        var self = this;
        var postData = {
          'doctorId': self.$route.params.parentId,
          'patientIds': patients };

        self.postData('/api/temi/medical/patient/doctor/' + self.$route.params.parentId, postData, function (res) {
          self.$message({
            message: '添加成功!',
            type: 'success' });

          self.searchData.page = 1;
          self.init();
        });
      } else {
        return false;
      }
    },
    delMenu: function delMenu(delId) {// 删除操作
      var self = this;
      self.$confirm('确定删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        self.delData('/api/temi/medical/patient/doctor/' + delId, {}, function (res) {
          self.$message({
            message: '删除成功!',
            type: 'success' });

          self.searchData.page = 1;
          self.init();
        });
      }).catch(function () {});
    },
    onCencal: function onCencal() {// 关闭弹出框
      this.$refs.addForm.resetFields();
      this.cleanData();
      this.newadd = false;
    },
    cleanData: function cleanData() {// 清理输入的数据
      this.addData = {
        id: '',
        name: '',
        age: '',
        complaint: '',
        hospitalTime: '',
        bedspace: '',
        sex: '' };

    },
    handleCheckAge: function handleCheckAge(rule, value, callback) {
      if (!value) {
        return callback(new Error('年龄不能为空'));
      }
      setTimeout(function () {
        if (!Number.isInteger(value)) {
          callback(new Error('请输入数字值'));
        } else {
          if (value < 1) {
            callback(new Error('必须年满1岁'));
          } else {
            callback();
          }
        }
      }, 500);
    },
    handleCheckMobile: function handleCheckMobile(rule, value, callback) {
      if (!value) {
        return callback(new Error('手机号不能为空'));
      }
      setTimeout(function () {
        var regx = /^[0-9]*$/;
        if (!regx.test(value)) {
          callback(new Error('请输入正确的手机号'));
        } else {
          callback();
        }
      }, 500);
    },
    returnFun: function returnFun(item) {
      // 返回上一级
      var self = this;
      // self.$router.push('/temi/task')
      self.$router.go(-1);
    } } };exports.default = _default;